module.exports = __webpack_public_path__ + "media/images/admin/icons/sunrise-8386c5eba76308c5979442ca37a79a6a.svg";